import React from 'react';
import DispensingEditablePopup from '../dispensingEditablePopup/DispensingEditablePopup';
import DispensingSimplePopup from '../dispensingSimplePopup/DispensingSimplePopup';

const DispensingSearchBar = (props) => {
  return (
    <div className="searchBar-conatiner">
      <div className="form-row">
        <div className="search-condition col-xl-2 col-sm-6">
          <label>장치목록</label>
          <select className="table-search-input up-check"
                  onChange={({ target: { value } }) => props.setSelectedModule(value)}>
            <option value="0">전체</option>
            {
              props.modules.map(module => {
                return (
                  <option key={module.moduleIdx}
                          value={module.moduleIdx}>
                    {module.modelNm}
                  </option>
                )
              })
            }
          </select>
        </div>
        <DispensingEditablePopup dispensing={[]} 
                                 dataReloadFunc={props.setTableData} 
                                 areas={props.areas}
                                 modules={props.modules.filter(x => x.dispensingFlag === 0)}>
          <div className="search-condition col-xl-1 col-sm-6">
            <button className="table-search-submit btn btn-info">불출</button>
          </div>
        </DispensingEditablePopup>
        <DispensingSimplePopup dataReloadFunc={props.setTableData}>
          <div className="search-condition col-xl-1 col-sm-6">
            <button className="table-search-submit btn btn-info">간편불출</button>
          </div>
        </DispensingSimplePopup>
        <div className="search-condition col-xl-1 col-sm-6">
          <button onClick={() => { props.returnTheModule(props.returnModuleList) }} className="table-search-submit btn btn-info">일괄반납</button>
        </div>
      </div>
    </div>
  )
}

export default DispensingSearchBar;